export default __webpack_public_path__ + "static/media/movie.2693e313.png";